export const manufacturerSerialRegex: Record<string, RegExp[]> = {
    // General fallbacks (more permissive, case-insensitive)
    default: [
        /\b[a-z0-9\-]{6,}\b/gi,
        /\b\d{8,}\b/g,
    ],

    // Prefer manufacturer-specific patterns first
    Emporia: [
        // More permissive: long alphanumeric (with optional dashes), 12–32 chars
        /\b[a-z0-9\-]{12,32}\b/gi,
        // Common prefixes seen on labels
        /\b(?:EMPORIA|EVSE|EM)[-_ ]?[a-z0-9\-]{5,}\b/gi,
        // Pure numeric barcodes (wide range)
        /\b\d{8,20}\b/g,
        // Split serials with hyphen/underscore
        /\b[a-z0-9]{5,}[-_][a-z0-9\-]{3,}\b/gi,
    ],

    ChargePoint: [
        /\bCP[-_ ]?[a-z0-9]{5,}\b/gi,
        /\bCPE?[-_ ]?[a-z0-9]{4,}\b/gi,
        /\b\d{7,12}\b/g,
    ],
};

export const extractSerialCandidates = (manufacturer: string, text: string): string[] => {
    const preview = (text || '').replace(/\n/g, ' ').slice(0, 200);
    // console.log('[OCR] extractSerialCandidates', { manufacturer, length: text?.length || 0, preview });
    const patterns = [
        ...(manufacturerSerialRegex[manufacturer] || []),
        ...manufacturerSerialRegex.default,
    ];
    const found = new Set<string>();
    for (const re of patterns) {
        const matches = text.match(re) || [];
        for (const m of matches) {
            const cleaned = m.replace(/[^A-Za-z0-9\-]/g, '').toUpperCase();
            if (cleaned.length >= 6) found.add(cleaned);
        }
    }
    if (found.size === 0) {
        const tokens = (text.match(/[A-Za-z0-9\-]+/g) || [])
            .map(t => ({ t, n: t.length }))
            .sort((a, b) => b.n - a.n)
            .slice(0, 10);
        console.log('[OCR] no serial candidates; top tokens by length:', tokens);
    }
    return Array.from(found);
};


